// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32f67463","915":"09075537"}[chunkId] + ".chunk.js";
};